import React, { Component } from 'react';
import ChartsComponent from "./charts-component";
import {connect} from "react-redux";
import {
  loadPrimaryEmotionsBreakdownRequest, loadSentimentBreakdownRequest,
  loadTopWordsRequest
} from "./charts-action-creators";



class ChartsContainer extends Component {

  componentDidMount() {
    const {
      whoMountedTopWords,
      whoMountedSentiment,
      whoMountedPrimary,
      loadTopWords,
      loadSentimentBreakdown,
      loadPrimaryEmotionsBreakdown,
      reportUrl
    } = this.props;
    whoMountedTopWords !== reportUrl ? loadTopWords(reportUrl) : null;
    whoMountedSentiment !== reportUrl ? loadSentimentBreakdown(reportUrl) : null;
    whoMountedPrimary !== reportUrl ? loadPrimaryEmotionsBreakdown(reportUrl) : null;
  }

  render() {
    return <ChartsComponent {...this.props} />
  }
}

const mapStateToProps = state => ({
  topWords: state.charts.topWords,
  topWordsLoading: state.charts.topWordsLoading,
  topWordsError: state.charts.topWordsError,
  sentimentBreakdown: state.charts.sentimentBreakdown,
  sentimentBreakdownLoading: state.charts.sentimentBreakdownLoading,
  sentimentBreakdownError: state.charts.sentimentBreakdownError,
  primaryEmotionsBreakdown: state.charts.primaryEmotionsBreakdown,
  primaryEmotionsBreakdownLoading: state.charts.primaryEmotionsBreakdownLoading,
  primaryEmotionsBreakdownError: state.charts.primaryEmotionsBreakdownError,
  reportUrl: state.report.reportUrl,
  whoMountedTopWords: state.charts.whoMountedTopWords,
  whoMountedSentiment: state.charts.whoMountedSentiment,
  whoMountedPrimary: state.charts.whoMountedPrimary,
});


const mapDispatchToProps = dispatch => ({
  loadTopWords: reportUrl => dispatch(loadTopWordsRequest(reportUrl)),
  loadSentimentBreakdown: reportUrl => dispatch(loadSentimentBreakdownRequest(reportUrl)),
  loadPrimaryEmotionsBreakdown: reportUrl => dispatch(loadPrimaryEmotionsBreakdownRequest(reportUrl))
});

export default connect(mapStateToProps, mapDispatchToProps)(ChartsContainer);


// WEBPACK FOOTER //
// ./src/modules/charts/charts-container.js